"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValueConstrictorEnum = void 0;
var ValueConstrictorEnum;
(function (ValueConstrictorEnum) {
    /** 收缩到指定的子集 */
    ValueConstrictorEnum["Subset"] = "subset";
    /** 排除指定的集合 */
    ValueConstrictorEnum["Exclude"] = "exclude";
    /** 收缩到指定子区间 */
    ValueConstrictorEnum["Range"] = "range";
})(ValueConstrictorEnum || (exports.ValueConstrictorEnum = ValueConstrictorEnum = {}));
